import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskHeatmap = ({ riskData }) => {
  const getRiskColor = (level) => {
    switch (level) {
      case 'critical': return 'bg-error text-error-foreground';
      case 'high': return 'bg-warning text-warning-foreground';
      case 'medium': return 'bg-accent text-accent-foreground';
      case 'low': return 'bg-success text-success-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getRiskIcon = (level) => {
    switch (level) {
      case 'critical': return 'AlertOctagon';
      case 'high': return 'AlertTriangle';
      case 'medium': return 'AlertCircle';
      case 'low': return 'CheckCircle2';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center">
          <Icon name="Flame" size={20} color="var(--color-error)" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">Peta Risiko</h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {riskData?.map((risk, index) => (
          <div key={index} className="p-4 rounded-lg border border-border hover:shadow-md transition-all duration-250">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg ${getRiskColor(risk?.level)} flex items-center justify-center`}>
                  <Icon name={getRiskIcon(risk?.level)} size={20} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground">{risk?.category}</h3>
                  <span className={`text-xs font-medium px-2 py-1 rounded ${getRiskColor(risk?.level)}`}>
                    {risk?.level?.toUpperCase()}
                  </span>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-foreground data-text">{risk?.score}</div>
                <div className="text-xs text-muted-foreground">Skor Risiko</div>
              </div>
            </div>

            <p className="text-sm text-muted-foreground mb-3">{risk?.description}</p>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Probabilitas</span>
                <span className="font-medium text-foreground">{risk?.probability}%</span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className={`h-full ${getRiskColor(risk?.level)}`}
                  style={{ width: `${risk?.probability}%` }}
                />
              </div>
            </div>

            <div className="space-y-2 mt-3">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Dampak</span>
                <span className="font-medium text-foreground">{risk?.impact}%</span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className={`h-full ${getRiskColor(risk?.level)}`}
                  style={{ width: `${risk?.impact}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskHeatmap;